import { SegmentDefinition } from '@fullstory/proto/fs/api/segment';
import { UnnamedSegment } from '@fullstory/proto/fs/services/dx-objects';

export enum UnnamedSegmentTypes {
  GetUnnamedSegmentRequest = 'UnnamedSegments.GetUnnamedSegment.Request',
  GetUnnamedSegmentSuccess = 'UnnamedSegments.GetUnnamedSegment.Success',
  GetUnnamedSegmentFailure = 'UnnamedSegments.GetUnnamedSegment.Failure',
  SaveUnnamedSegmentRequest = 'UnnamedSegments.SaveUnnamedSegment.Request',
  SaveUnnamedSegmentSuccess = 'UnnamedSegments.SaveUnnamedSegment.Success',
  SaveUnnamedSegmentFailure = 'UnnamedSegments.SaveUnnamedSegment.Failure',
}

export interface UnnamedSegmentRecord {
  // id uniquely  identifies an unnamed segment.
  // It will always exist but does not necessarily indicate that an unnamed segment has been persisted.
  id: string;

  // segmentDefinition holds the underlying segment definition.
  // Exists if created locally or loaded from the server.
  // Its presence does necessarily indicate that the unnamed segment has been persisted.
  segmentDefinition: SegmentDefinition | null;

  // disabled holds the underlying disabled state.
  // Always exists (empty if not set yet), set if created locally or loaded from the server.
  // Its presence does necessarily indicate that the unnamed segment has been persisted.
  disabled: UnnamedSegment.Disabled;

  // state holds the underlying persistence state.
  // This is the only reliable indicator of persistence.
  // If the state is null, no persistence state has been determined (i.e. if loaded from navigate state).
  state: UnnamedSegmentState | null;

  // name is an optional name for the unnamed segment
  // If set, the value will be used to in unnamed segments to override the underlying segment name.
  // If no name override is desired, set to empty string.
  name: string;

  // description is optional for the unnamed segment
  description: string;
}

export enum UnnamedSegmentState {
  // No known state yet, an action is pending.
  Pending,
  // Known to be persisted (either through a successful save or successful get).
  Persisted,
  // Failed to be persisted or retrieved, can be retried.
  // Note: The unnamed segment might still exist locally. Not persisted != not exists.
  //       Additionally, a get request could have failed signaling NotPersisted but a retry could still succeed.
  NotPersisted,
}
